<template>
  <RevCard
    class="w-full min-h-fit border-static-brand-hi border overflow-hidden cursor-pointer"
    @click="openModal(MODAL_NAMES.BACK_MARKET_PROMISE)"
  >
    <div class="py-12 px-16 bg-static-info-max flex items-center">
      <IconBackMarketPromiseFilled size="24" />
      <h3 class="text-action-default-hi body-2-bold ml-12 mr-4">
        {{ i18n(translations.cardTitle) }}
      </h3>
      <IconChevronRight size="24" />
    </div>

    <div class="pt-16 pb-8 px-24 flex flex-col items-center">
      <div class="heading-3 text-static-default-hi mb-8">
        {{ i18n(translations.oneYearWarrantyTitle) }}
      </div>
      <div class="body-2 text-static-default-low mb-24 text-center">
        {{ i18n(translations.oneYearWarrantyDescription) }}
      </div>
      <div class="flex caption gap-32 text-action-default-hi">
        <div class="flex items-center gap-2">
          <IconCycle size="16" />
          {{ i18n(translations.free30DayReturns) }}
        </div>
        <div class="flex items-center gap-2">
          <IconHeadset size="16" />
          {{ i18n(translations.realCustomerCare) }}
        </div>
      </div>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { openModal } from '@ds/components/ModalBase'
import { IconBackMarketPromiseFilled } from '@ds/icons/IconBackMarketPromiseFilled'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconCycle } from '@ds/icons/IconCycle'
import { IconHeadset } from '@ds/icons/IconHeadset'

import { MODAL_NAMES } from '~/scopes/checkout/config/constants'

import translations from './BackMarketPromiseCard.translations'

const i18n = useI18n()
</script>
